import {useEffect, useMemo, useState} from 'react'
import {useAuth} from '../core/Auth'

const formatRemaining = (seconds: number) => {
  const safe = Math.max(0, seconds)
  const minutes = Math.floor(safe / 60)
  const rest = safe % 60
  return `${minutes.toLocaleString('fa-IR')}:${rest.toLocaleString('fa-IR', {
    minimumIntegerDigits: 2,
  })}`
}

const SupportSessionBanner = () => {
  const {currentUser, logout} = useAuth()
  const support = currentUser?.support
  const [now, setNow] = useState(() => Date.now())
  const [blockedMessage, setBlockedMessage] = useState('')
  const remaining = useMemo(
    () => Math.max(0, Math.floor(((support?.expires_at || 0) * 1000 - now) / 1000)),
    [now, support?.expires_at]
  )

  useEffect(() => {
    if (!support) return
    const timer = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(timer)
  }, [support])

  useEffect(() => {
    if (!support || remaining > 0) return
    logout({server: false})
    window.location.replace('/auth/login')
  }, [logout, remaining, support])

  useEffect(() => {
    const handleBlocked = (event: Event) => {
      const detail = (event as CustomEvent<{message?: string}>).detail
      setBlockedMessage(detail?.message || 'این عملیات در حالت پشتیبانی مجاز نیست.')
      window.setTimeout(() => setBlockedMessage(''), 5000)
    }
    window.addEventListener('megapay:support:readonly-blocked', handleBlocked)
    return () => window.removeEventListener('megapay:support:readonly-blocked', handleBlocked)
  }, [])

  if (!support) return null

  const exitSupport = () => {
    logout()
    window.setTimeout(() => {
      if (window.opener) window.close()
      else window.location.replace('/auth/login')
    }, 150)
  }

  return (
    <div className='bg-warning-subtle border-bottom border-warning px-4 py-3' role='status'>
      <div className='d-flex flex-wrap align-items-center justify-content-between gap-3'>
        <div className='d-flex align-items-start gap-3'>
          <i className='las la-shield-alt fs-1 text-warning-emphasis' aria-hidden='true' />
          <div>
            <strong className='d-block text-warning-emphasis'>حالت پشتیبانی فعال است</strong>
            <span className='text-gray-800'>
              برای «{support.company_name}» می‌توانید «کارپوشه مالیاتی»، «کاربران و دسترسی‌ها» و
              «تنظیمات اتصال حسابداری» را تغییر دهید؛ سایر بخش‌ها فقط‌خواندنی‌اند و هر تغییر با نام
              شما ثبت می‌شود.
            </span>
            <small className='d-block text-gray-700 mt-1'>
              کارشناس: {support.operator_name || support.crm_user_id} · زمان باقی‌مانده:{' '}
              {formatRemaining(remaining)}
            </small>
            {blockedMessage && <div className='text-danger fw-bold mt-1'>{blockedMessage}</div>}
          </div>
        </div>
        <button type='button' className='btn btn-sm btn-dark' onClick={exitSupport}>
          <i className='las la-sign-out-alt fs-4' /> خروج از حالت پشتیبانی
        </button>
      </div>
    </div>
  )
}

export {SupportSessionBanner}
